module.exports = __webpack_public_path__ + "static/media/Blue.0b018e60.mp4";